import React from 'react'
import './Abtcont.css'
import { FaChevronRight } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom';

function Abtcont() {
  const navigate = useNavigate();
  return (
    <section className='abtcont'>
        <div className='container'>
            <h3>Ready for the next step in your <br/> digital transformation?</h3>
            <p>Let's transform your customer experience.</p>
            <button className='btn-main' onClick={() => navigate('/contact')}><span>Contact Us</span> <FaChevronRight/></button>
        </div>
    </section>
  )
}

export default Abtcont
